import { createFileRoute } from '@tanstack/react-router';
import { RequireRole } from '../components/RequireRole';
import { MyCommissions } from '../features/finance/MyCommissions';

export const Route = createFileRoute('/mes-commissions')({
  component: () => (
    <RequireRole allow={['vendeur']}>
      <MyCommissions />
    </RequireRole>
  ),
});
